export default {
    namespaced: true,
    state: {
        countries: null,
    },
    mutations: {
        setCountries: (state, countries) => {
            state.countries = countries;
        },
    },
    actions: {
        getCountries(context) {
            return this.$axios.get('/countries')
                .then(response => {
                    if(response.data.countries) {
                        context.commit('setCountries', response.data.countries);
                    }

                    return response;
                });
        },
    },
    getters: {
        getCountries: (state) => {
            return state.countries;
        },
    }
}
